import { Component, Inject }                      from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA }                    from '@angular/material';
import { PeakService }                    from './../shared/peak.service';
import { Globals }                        from './../common/globals';
import { HolidayExceptionService } from '../shared/holiday-exception.service';
import { TrainService } from '../shared/train.service';
import { SortableFilter, ISortableFilter } from '../common/sortable-filter';
import { HolidayExceptionItemModel } from '../holiday-exception-list/holiday-exception-item.model';

@Component({
  selector: 'sa-holiday-exception-dialog',
  template: require('./holiday-exception-dialog.component.html'),
  styles: [require('./holiday-exception-dialog.component.scss')]
})
export class HolidayExceptionDialogComponent {
  public model: HolidayExceptionItemModel;
  public newItem = false;
  public trains: any[];
  public trainsReady = false;
  public filterReady = false;

  trainFilter: ISortableFilter = new SortableFilter('trainName');

  public errors = [];
  constructor(
    trainService: TrainService,
    public dialogRef: MatDialogRef<HolidayExceptionDialogComponent>,
    public holidayService: HolidayExceptionService,
    public globals: Globals,
    // @Inject(MAT_DIALOG_DATA) private data: {model: HolidayExceptionItemModel},
  ) {

    trainService.getNames(this.trainFilter)
      .subscribe(t => {
        this.trains = t;
        this.trainsReady = true;
      });
  }

  save() {
    this.errors = [];
    if (this.errors.length === 0) {
      this.dialogRef.close('save');
    }
  }

  delete() {
    if (confirm('Opravdu si přejete odstranit tento záznam?')) {
      this.dialogRef.close('delete');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/holiday-exception-dialog/holiday-exception-dialog.component.ts